// sections/HowItWorksSection.tsx
import React from "react";
import { Container, Row, Col } from "reactstrap";
import { FileText, Clock, Users, CheckCircle } from "lucide-react";

const HowItWorksSection: React.FC = () => {
  const steps = [
    {
      icon: FileText,
      title: "Post Your Project With Precision",
      description: "Detail every aspect including measurements, photos, plans, videos, or previous estimates",
      bgColor: "bg-primary",
      textColor: "text-white",
    },
    {
      icon: Clock,
      title: "Get Instant Contingent Quotes",
      description: "Contractors provide swift preliminary estimates without the wait",
      bgColor: "bg-primary",
      textColor: "text-white",
    },
    {
      icon: Users,
      title: "Select With Confidence",
      description: "Choose your preferred contractor based on contingent quotes, subject to inspection",
      bgColor: "bg-primary",
      textColor: "text-white",
    },
    {
      icon: CheckCircle,
      title: "Finalize & Start Your Project",
      description: "After inspection, contractor removes contingency or proposes adjustments before starting",
      bgColor: "bg-warning",
      textColor: "text-dark",
    },
  ];

  const handleIconClick = () => {
    window.location.href = "/create-job";
  };

  return (
    <section id="how-it-works" className="py-5 bg-light">
      <Container>
      <h2 className="fs-1 fw-bold text-center mb-2" style={{ marginTop: '100px' }}>How BidBro Works</h2>
        {/*
        <p className="text-center text-muted mb-5">Pulling price forward in the process, saving you time and hassle</p>
        */}
        <Row>
          {steps.map((step, index) => (
            <Col md="3" className="text-center p-4" key={index}>
              <div 
                className={`icon-circle ${step.bgColor} d-flex align-items-center justify-content-center mx-auto mb-4`}
                onClick={handleIconClick}
                style={{ 
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <step.icon className={step.textColor} />
              </div>
              <h3 
                className="fs-5 fw-semibold mb-3"
                onClick={handleIconClick}
                style={{ 
                  cursor: 'pointer',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#0d6efd';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '';
                }}
              >
                {step.title}
              </h3>
              <p className="text-muted">
                {step.description}
              </p>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HowItWorksSection;